'use client';
import { styleKeyVarMap } from './style-keys.utils.js';

function asyncGeneratorStep(e, t, r, n, o, c, i) {
    try {
        var s = e[c](i), p = s.value;
    } catch (e) {
        r(e);
        return;
    }
    s.done ? t(p) : Promise.resolve(p).then(n, o);
}
function _async_to_generator(e) {
    return function() {
        var t = this, r = arguments;
        return new Promise(function(n, o) {
            var c = e.apply(t, r);
            function _next(e) {
                asyncGeneratorStep(c, n, o, _next, _throw, "next", e);
            }
            function _throw(e) {
                asyncGeneratorStep(c, n, o, _next, _throw, "throw", e);
            }
            _next(void 0);
        });
    };
}
function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function waitForStyles() {
    return _waitForStyles.apply(this, arguments);
}
function _waitForStyles() {
    return (_waitForStyles = _async_to_generator(function*(t = 5000) {
        let r = Date.now();
        return new Promise((n, o)=>{
            let checkStyles = ()=>{
                let c = getComputedStyle(document.documentElement);
                Object.values(styleKeyVarMap).every((e)=>!e || '1' === c.getPropertyValue(e)) ? n() : Date.now() - r >= t ? (console.log('Loaded styles:', JSON.stringify(Object.entries(styleKeyVarMap).reduce((e, [t, r])=>r ? _object_spread_props(_object_spread({}, e), {
                        [t]: '1' === c.getPropertyValue(t)
                    }) : _object_spread_props(_object_spread({}, e), {
                        [t]: true
                    }), {}), null, 2)), o(Error('Timeout exceeded while waiting for styles to load'))) : setTimeout(checkStyles, 100);
            };
            checkStyles();
        });
    })).apply(this, arguments);
}

export { waitForStyles };
